<template>
  <div>
    <h3>企业额外信息</h3>
    <div class="edit-btns">
      <a-button
        v-if="permissions && permissions.includes('编辑')"
        slot="extra"
        type="primary"
        class="margin-bottom-20"
        @click="editExtra"
      >
        编辑
      </a-button>
    </div>

    <CardEdit
      ref="formExtra"
      :source-data="sourceDataExtra"
      :schema="EXTRA_INFO_SCHEMA"
      layout="horizontal"
      :labelCol="labelColExtra"
      :wrapperCol="wrapperColExtra"
      :defaultColMd="24"
      :defaultColLg="12"
      :defaultColXl="12"
    >
      <!-- 操作区域 -->
      <template v-slot:operate-area>
        <div v-show="extraButtonsShow" style="text-align:right">
          <a-button type="" @click="handleCancelExtra">
            取消
          </a-button>
          <a-button
            type="primary"
            class="margin-left-10"
            @click="handleSubmitExtra"
          >
            保存
          </a-button>
        </div>
      </template>
    </CardEdit>
  </div>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
import mixin from './mixinExtra'
import { addCuntomerDetails } from '../api'
export default {
  props: ['customerDetail', 'permissions'],
  components: {
    CardEdit,
  },
  mixins: [mixin],
  name: 'create-form',
  data() {
    return {
      loading: true,
      checkboxList: [],
      tableRow: {},
      filters: [],
      destroyOnClose: true,
      activeKey: [1, 2],
      codeJuage: false, //todo 判断？
      oId: '', //basic ID
      basicOperating: true, // 企业基本信息是否可操作
      extraButtonsShow: false, //企业额外信息按钮是否展现
      businessList: [], //业务类型
      regionOptionList: [], //大区/模式 optionList
    }
  },
  computed: {
    // 信用主管默认选择当前用户
  },
  mounted() {
    //this.establishYearList()
    this.coopTimeList()
    setTimeout(() => {
      this.query()
    }, 1000)
  },
  methods: {
    // 初始化额外信息
    async query() {
      var formatData = {
        isExpiryRisk: '2',
        isExpiry: '2',
        establishYear: '1949',
        coopTime: '0',
      }
      Object.keys(formatData).forEach(k => {
        this.sourceDataExtra[k] = formatData[k] + '' || ''
      })

      if (
        this.customerDetail &&
        this.customerDetail.detail &&
        this.customerDetail.detail.length != 0
      ) {
        // 企业基本信息内容
        for (let key in this.sourceDataExtra) {
          this.loading = false
          if (
            key === 'establishYear' ||
            key === 'coopTime' ||
            key === 'isExpiryRisk' ||
            key === 'isExpiry'
          ) {
            this.sourceDataExtra[key] =
              (await this.customerDetail.detail[key]) + ''
          } else {
            this.sourceDataExtra[key] = await this.customerDetail.detail[key]
          }
        }
      }
    },
    // 成立年限
    // establishYearList() {
    //   var year = new Date().getFullYear()
    //   for (var i = 1949; i < year + 1; i++) {
    //     this.EXTRA_INFO_SCHEMA.establishYear.optionList.push({
    //       label: i + '',
    //       value: i + ''
    //     })
    //   }
    // },
    // 合作年限
    coopTimeList() {
      for (var i = 0; i < 51; i++) {
        this.EXTRA_INFO_SCHEMA.coopTime.optionList.push({
          label: i + '',
          value: i + '',
        })
      }
    },

    //编辑-企业额外信息
    editExtra() {
      this.extraButtonsShow = true
      for (let key in this.EXTRA_INFO_SCHEMA) {
        this.EXTRA_INFO_SCHEMA[key].disabled = false
      }
    },
    // 校验 - 企业额外信息
    async validateFormExtra() {
      try {
        const values = await this.$refs.formExtra.handleSubmit()
        const passed = !!values
        if (passed) {
          for (let key in this.sourceDataExtra) {
            if (key !== 'companyCode') {
              if (values[key] !== undefined) {
                this.sourceDataExtra[key] = values[key]
              }
            }
          }
          return this.sourceDataExtra
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 保存 - 企业额外信息
    async handleSubmitExtra() {
      var data = await this.validateFormExtra()
      if (data) {
        addCuntomerDetails(data).then(({ message }) => {
          this.$message.success(message)
          this.extraButtonsShow = false
          // disabled
          for (let key in this.EXTRA_INFO_SCHEMA) {
            this.EXTRA_INFO_SCHEMA[key].disabled = true
          }
        })
      }
    },
    // 取消 - 企业额外信息
    handleCancelExtra() {
      this.$refs.formExtra.handleReset()
      this.extraButtonsShow = false
      for (let key in this.EXTRA_INFO_SCHEMA) {
        this.EXTRA_INFO_SCHEMA[key].disabled = true
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .margin-left-10 {
  margin-left: 10px;
}
.margin-bottom-20 {
  margin-bottom: 20px;
}
.client-center-home
  /deep/
  .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header {
  line-height: 30px;
}
.edit-btns {
  text-align: right;
}
</style>
